import React, { useEffect, useRef } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "../../../hooks/make-styles-wrapper";

const useStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            {
                width: "400px",

                [theme.breakpoints.down(350)]: {
                    width: "275px",
                },
                [theme.breakpoints.between(350, 390)]: {
                    width: "300px",
                },
                [theme.breakpoints.between(390, 440)]: {
                    width: "350px",
                },
            },
            overrides,
        ),
    }),
    "successBlurb.container",
);

const SuccessBlurb = (props) => {
    const {
        title,
        body,
        index,
        onComplete,
    } = props;

    const containerStyles = useStyles();

    const runOnComplete = useRef(async () => {
        await onComplete(index);
    });

    useEffect(() => {
        const onCompleteTimer = setTimeout(() => {
            runOnComplete.current();
        }, 1000);
        return () => clearTimeout(onCompleteTimer);
    }, []);

    return (
        <Box className={containerStyles.root}>
            <Box
                textAlign="center"
                mb={1}
            >
                <Typography
                    component="h2"
                    variant="h2"
                    color="primary"
                    style={{ fontSize: "30px", fontWeight: "900" }}
                >
                    {title}
                </Typography>
            </Box>
            <Box
                textAlign="center"
                my={3}
            >
                <Typography
                    component="p"
                    variant="body1"
                    style={{ fontSize: "16px" }}
                >
                    {body}
                </Typography>
            </Box>
        </Box>
    );
};

export default SuccessBlurb;